// leaseScenarioAnalytics.js — Customer Value telemetry, Slice 2 (Lease Scenarios)
//
// Thin, declarative wrappers over lib/analytics.track. The Scenarios page save
// is an UPSERT, so `lease_scenario_saved` carries an `is_new` flag to cover both
// Created and Edited without duplicate semantics. `lease_scenario_compared`
// fires when a real ≥2-way comparison is realized. No select/delete events —
// those interactions do not exist in the workflow (not invented). track()
// injects the BL-025 `environment` tag.
//
// PII-safe (ADR-040): scenario_type enum + counts/flags only.

import { track } from './analytics';

// Create-or-edit of a lease scenario (Creation Rate, M-019).
export function leaseScenarioSaved({ scenario_type, is_new } = {}) {
  track('lease_scenario_saved', { scenario_type, is_new });
}

// A real multi-scenario comparison was viewed (Comparison Rate, M-020) —
// the core lease-leverage value moment.
export function leaseScenarioCompared({ scenario_count } = {}) {
  track('lease_scenario_compared', { scenario_count });
}
